<script>
  export let id

  import { link } from 'svelte-navigator'
  import { postO } from '../../oauth.js'

  let workoutPlan

  async function cloneWorkoutPlan() {
    const response = await postO('/workout_plans/' + id + '/clone/')
    workoutPlan = await response.json()
    console.log('Clone Result', workoutPlan)
  }
  cloneWorkoutPlan()
</script>

{#if !workoutPlan}
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
{:else}
  <h1>Plan {workoutPlan.title}</h1>
  <i
    >The Workout Plan was succesfully cloned into your account. What do you want
    to do next?</i
  >
  <div class="list-group">
    <a
      class="list-group-item list-group-item-action"
      href="/workoutplans/edit/{workoutPlan.id}"
      use:link>View or Edit the Plan</a
    >
    <a
      class="list-group-item list-group-item-action"
      href="/workoutplans/train/{workoutPlan.id}"
      use:link>Train the Plan</a
    >
    <a
      class="list-group-item list-group-item-action"
      href="/workoutplans"
      use:link>Back to Workout Plan List</a
    >
  </div>
{/if}

<svelte:head>
  {#if workoutPlan}
    <title>Clone Fich Workout Plan {workoutPlan.title}</title>
  {/if}
</svelte:head>
